import {
    FadeOut
} from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import { Group } from "slotworks/graphics/pixi/group";
import RevolverWinTransitions from "slotworks/integration/revolver/transitions/revolver-win-transitions";
import SoundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contract";
import Point from "slotworks/utils/geom/point";
import { parallel, sequence } from "slotworks/utils/race-utils";
import Timer from "slotworks/utils/timer";
import * as TweenJS from "slotworks/utils/tween";

export default class SuperMegaWinTransitions extends RevolverWinTransitions {
    public EXPLOSION_TIME: number = 9500;
    public TEXT_ZOOM = 1.5;

    private rays: PIXI.Sprite;
    private supermega: PIXI.Container;

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.inResolve = resolve;
            this.rays = Layers.CelebrationContent.getSprite("rays");

            this.supermega = Group([Layers.CelebrationContent.getSprite("super"), Layers.CelebrationContent.getSprite("mega2")], "supermega");

            RevolverWinTransitions.gemShower.emit = true;

            parallel([
                () => Contract.wrap(() => {
                    SoundManager.customEvent("supermega_win");
                }),
                () => this.introduce(this.supermega, this.EXPLODE_DELAY, new Point(0.5, 1), 0.5),
                () => this.introduce(RevolverWinTransitions.winText, this.EXPLODE_DELAY, new Point(0.5, 1), 0.5),
                () => this.introduce(RevolverWinTransitions.winValue, this.EXPLODE_DELAY, new Point(0.5, 0.5), 0.5)
            ]).then(() => {
                RevolverWinTransitions.winTextHover.onLoop(() => {
                    this.zoomTextIn(this.TEXT_ZOOM, this.EXPLOSION_TIME).execute();
                    if (RevolverWinTransitions.winText.scale.x === 1) {
                        this.endlessHover(this.supermega);
                        RevolverWinTransitions.winTextHover.onLoop(null);
                    }
                });

                this.resolveIn();
            });

            this.timers.push(Timer.setTimeout(() => {

                this.animateRays();

            }, this.EXPLODE_DELAY));
        });
    }

    public skipIn() {
        this.destroy();

        if (this.rays) {
            this.rays.visible = false;
        }
        RevolverWinTransitions.blastLeft.emit = false;
        RevolverWinTransitions.blastRight.emit = false;
        RevolverWinTransitions.explodeEmitter.emit = false;

        RevolverWinTransitions.gemShower.emit = true;

        RevolverWinTransitions.winText.visible = true;
        RevolverWinTransitions.winValue.visible = true;

        this.endlessHover(this.supermega);
        SoundManager.customEvent("supermega_win");

        this.setTextSize(this.TEXT_ZOOM);

        this.resolveIn();
    }

    public out(): Contract<void> {
        return sequence([
            () => Contract.wrap(() => {
                TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
            }),
            () => this.groupAndAnimateOut(this.supermega),
            () => Contract.wrap(() => {
                this.clearTimers();
                this.supermega.visible = false;
                RevolverWinTransitions.winText.visible = false;
                SoundManager.customEvent("celebration_end");
            }),
            () => FadeOut(RevolverWinTransitions.background, this.BOUNCE_TIME * 0.5),
            () => Contract.wrap(() => {
                RevolverWinTransitions.coinShower.emit = false;
                RevolverWinTransitions.gemShower.emit = false;
            }),
            () => Contract.getTimeoutContract(1000)
        ]);
    }

    public destroy() {
        this.clearTimers();

        TweenJS.removeAll(this.rays);
        TweenJS.removeAll(RevolverWinTransitions.winText.scale);

        TweenJS.removeAll(this.supermega.scale);
        TweenJS.removeAll(this.supermega);

        super.destroy();
    }

    private animateRays() {
        const frameTime = 1000 / 16;

        if (this.rays) {
            this.rays.visible = true;
            this.rays.anchor.set(0.5, 0.5);
            this.rays.x += this.rays.width * 0.5;
            this.rays.y += this.rays.height * 0.5;
            this.rays.scale = new PIXI.Point(3, 3);

            const zoomA = new TweenJS.Tween(this.rays.scale)
                .to({x: 6, y: 6}, frameTime * 3);
            const zoomB = new TweenJS.Tween(this.rays.scale)
                .to({x: 3, y: 3}, frameTime * 21);

            zoomA.chain(zoomB).start();

            new TweenJS.Tween(this.rays)
                .to({rotation: 15 * Math.PI / 180}, frameTime * 24)
                .start();

            new TweenJS.Tween(this.rays)
                .delay(frameTime * 10)
                .to({alpha: 0}, frameTime * 14)
                .start();
        }
    }

}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/transitions/super-mega-win-transitions.ts